module.exports = __webpack_public_path__ + "img/logo-ongame.1baa6237.png";